export const EMAIL_REGEX = new RegExp('^[A-Z0-9._%+-]+@[A-Z0-9.-]+\\.[A-Z]{2,4}$', 'i');
export const EMAIL_REGEX_2 = new RegExp('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$', 'i');
export const EXP_NAME = new RegExp('^[\\w\'\\-,.][^0-9_!¡?÷?¿/\\\\+=@#$%ˆ&*(){}|~<>;:[\\]]{2,}$', 'i');
export const EXP_PASSWORD = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)([A-Za-z\\d$@$!%#*?&]|[^ ]){8,15}$', 'i');
export const RFC_REGEX = new RegExp('^([A-ZÑ&]{3,4}) ?(?:- ?)?(\\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\\d|3[01])) ?(?:- ?)?([A-Z\\d]{2})([A\\d])$', 'i');
export const BANCK_ACCOUNT_REGEX = new RegExp('^(\\d){18,18}$', 'i');
export const NUMBER_REGEX = new RegExp('^[0-9,.\\s]*$', 'i');
export const PHONE_NUMBER_REGEX = new RegExp('([0-9]|\\+)[0-9]{9,15}$', 'i');
